import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCompanies } from '../useCompanies';
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { getUser } from 'hooks/useUser';
import { getCompanyViewSections } from '../companyViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleCompany = () => {
  const { t } = useTranslation();
  const user = useRecoilValue(getUser);
  const { singleItem, apiLoading } = useCompanies(false);

  const sections = useMemo(
    () =>
      getCompanyViewSections(t, singleItem, {
        isRoot: user?.retail_or_root,
      }),
    [t, singleItem, user?.retail_or_root],
  );

  return (
    <div>
      <PageHeader title={t('INSEGNE')} />
      <div className={styles.content}>
        <Spin spinning={apiLoading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/admin/companies/${singleItem?.id}/edit`}>
                  {t('MODIFIICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/admin/companies'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleCompany;
